<template>
  <div class="invite-codes-page">
    <h2>我的邀请码</h2>
    <p class="hint">生成邀请码分享给好友，好友注册时填写即可建立邀请关系。您自己生成的邀请码近 7 天内最多 5 个（按已生成记录滚动计算），管理员发放的不占用此额度。</p>

    <div class="toolbar">
      <el-button type="primary" :loading="creating" @click="createCode">生成新邀请码</el-button>
      <el-select v-model="isUsedFilter" class="filter-select" @change="fetchList">
        <el-option label="全部" :value="-1" />
        <el-option label="未使用" :value="0" />
        <el-option label="已使用" :value="1" />
      </el-select>
      <el-button @click="fetchList">刷新</el-button>
    </div>

    <el-table :data="codes" v-loading="loading" style="width: 100%; margin-top: 16px">
      <el-table-column prop="code" label="邀请码" width="140">
        <template #default="scope">
          <span class="code-text">{{ scope.row.code }}</span>
          <el-button link type="primary" size="small" @click="copyCode(scope.row.code)">复制</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="ownerUuid" label="我的用户 UUID" min-width="200" show-overflow-tooltip />
      <el-table-column prop="isUsed" label="状态" width="100">
        <template #default="scope">
          <el-tag :type="scope.row.isUsed === 1 ? 'info' : 'success'">
            {{ scope.row.isUsed === 1 ? '已使用' : '未使用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="使用者" min-width="120">
        <template #default="scope">
          <template v-if="scope.row.usedByUuid">
            <div>{{ scope.row.usedByUsername || '—' }}</div>
            <div class="used-uuid">{{ scope.row.usedByUuid }}</div>
          </template>
          <span v-else>—</span>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" width="170">
        <template #default="scope">{{ formatTime(scope.row.createdAt) }}</template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="total > pageSize"
      class="pager"
      layout="prev, pager, next"
      :total="total"
      :page-size="pageSize"
      :current-page="page"
      @current-change="onPageChange"
    />
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'InviteCodesView',
  data() {
    return {
      loading: false,
      creating: false,
      codes: [],
      total: 0,
      page: 1,
      pageSize: 20,
      isUsedFilter: -1
    }
  },
  created() {
    if (!localStorage.getItem('jwt_token')) {
      this.$goToLogin(this.$route.fullPath)
      return
    }
    this.fetchList()
  },
  methods: {
    formatTime(ts) {
      if (!ts) return '—'
      return new Date(ts * 1000).toLocaleString()
    },
    async fetchList() {
      this.loading = true
      try {
        const res = await axios.post('/api/v1/invite/code/my-list', {
          page: this.page,
          pageSize: this.pageSize,
          isUsed: this.isUsedFilter
        })
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '加载失败')
          return
        }
        this.codes = res.data.data?.codes || []
        this.total = res.data.data?.total || 0
      } catch (e) {
        this.$message.error(e.response?.data?.message || '加载失败')
      } finally {
        this.loading = false
      }
    },
    async createCode() {
      this.creating = true
      try {
        const res = await axios.post('/api/v1/invite/code/create', {})
        if (res.data.code !== 200) {
          this.$message.error(res.data.message || '生成失败')
          return
        }
        this.$message.success('邀请码已生成')
        this.page = 1
        await this.fetchList()
      } catch (e) {
        this.$message.error(e.response?.data?.message || '生成失败')
      } finally {
        this.creating = false
      }
    },
    copyCode(code) {
      navigator.clipboard.writeText(code).then(() => {
        this.$message.success('已复制邀请码')
      }).catch(() => {
        this.$message.warning('复制失败，请手动复制：' + code)
      })
    },
    onPageChange(p) {
      this.page = p
      this.fetchList()
    }
  }
}
</script>

<style scoped>
.invite-codes-page {
  max-width: 900px;
  margin: 0 auto;
  padding: 24px 16px;
}
.hint { color: #606266; margin-bottom: 16px; }
.toolbar { display: flex; gap: 12px; align-items: center; flex-wrap: wrap; }
.filter-select { width: 120px; }
.code-text { font-family: monospace; font-weight: 600; margin-right: 8px; }
.used-uuid { font-size: 12px; color: #909399; word-break: break-all; }
.pager { margin-top: 16px; justify-content: center; }
</style>
